import React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'

export const reportingStatusQuery = gql`
  query ReportingStatusQuery {
    reportingStatus {
      enabled
    }
  }
`

export interface ReportingStatus {
  readonly enabled: boolean
}

interface ReportingStatusQueryProps {
  readonly children: (props: {
    readonly status?: ReportingStatus
    readonly loading: boolean
  }) => React.ReactNode
}

export function ReportingStatusQuery({ children }: ReportingStatusQueryProps) {
  return (
    <Query<
      {
        readonly reportingStatus: ReportingStatus
      },
      {}
    >
      query={reportingStatusQuery}
      fetchPolicy="network-only"
    >
      {({ data, loading }) => {
        return children({
          status: !!data ? data.reportingStatus : undefined,
          loading
        })
      }}
    </Query>
  )
}
